import script from "./MathRushPage.vue?vue&type=script&setup=true&lang=js"
export * from "./MathRushPage.vue?vue&type=script&setup=true&lang=js"

import "./MathRushPage.vue?vue&type=style&index=0&id=70a973e6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-70a973e6"]])

export default __exports__